module.exports = __webpack_public_path__ + "static/MessinaSansWeb-SemiBold-615ab63b853d7f06cbbff409c367375a.woff2";